import { render } from "./NAttachmentsAmount.vue?vue&type=template&id=a3d31668&ts=true"
import script from "./NAttachmentsAmount.vue?vue&type=script&lang=ts"
export * from "./NAttachmentsAmount.vue?vue&type=script&lang=ts"

import "./NAttachmentsAmount.vue?vue&type=style&index=0&id=a3d31668&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__